import {BaseContainerModel} from '../../base-container.model';

import { bl_crm_membership_points_to_currency_rate_hdr_RowClass } from '../../../dbschema/bl_crm_membership_points_to_currency_rate_hdr.model';

export class MembershipPointstoCurrencyRateContainerModel extends BaseContainerModel {
  bl_crm_membership_points_to_currency_rate: bl_crm_membership_points_to_currency_rate_hdr_RowClass = new bl_crm_membership_points_to_currency_rate_hdr_RowClass();
  
}
